import { render, staticRenderFns } from "./UpdateCampaignFallback.vue?vue&type=template&id=4541a29a"
import script from "./UpdateCampaignFallback.vue?vue&type=script&lang=js"
export * from "./UpdateCampaignFallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports